export { default } from './FormatWarningTooltip';
